<template>
    <div>
        <form-input-mail-address
            @input="updateIsValidMailAddress"
            :initial-mail-address="value"
            label="required"
        />
        <list-text :comments="true" class="is-mgb16">
            <li class="m-list-text-item">
                こちらのメールアドレスに<span class="is-caution"
                    >「申込完了」</span
                >と<span class="is-caution">「審査結果」</span
                >をご連絡しますので、必ず受け取れるメールアドレスを入力してください。
            </li>
            <li class="m-list-text-item">
                サポート対応のご連絡やサービス向上のためにアンケートのご協力をお願いする場合がございます。
            </li>
        </list-text>
    </div>
</template>

<script>
import FormInputText from "../atoms/FormInputText.vue";
import ListText from "../atoms/ListText.vue";
import FormInputMailAddress from "../molecules/FormInputMailAddress.vue";

export default {
    name: "JhsFreeInputProfileItemMailAddress",
    components: {
        FormInputText,
        ListText,
        FormInputMailAddress
    },
    props: {
        /**
         * storeのmailAddress
         */
        value: {
            type: String,
            required: true
        }
    },
    emits: ['input'],
    methods: {
        /**
         * 有効なメールアドレスの値かnullが子から渡ってくるので受け取り親にもそのまま渡す
         */
        updateIsValidMailAddress(inputMailAddress) {
            this.$emit("input", inputMailAddress);
        }
    }
};
</script>
